export default {"src":"/_next/static/media/map-marker-black.119b522b.svg","height":40,"width":40,"blurWidth":0,"blurHeight":0};